<style lang="scss">
.message-comp {
  $colorSender: #5e50ee;
  $colorReceiver: #F7F7F7;

  &__item {
    background-color: $colorReceiver;
    border-radius: 2em;
    max-width: 80%;
    margin-left: auto;
    padding-bottom: 5px !important;
    box-shadow: 0 2px 4px rgba(0,0,0,.2);

    &:hover {
      box-shadow: none;
    }

    &.receiver {
      margin-left: unset;
      background-color: $colorSender;

      p {
        color: white;
      }
    }

    &__message {
      color: black;
    }
  }
}
</style>

<!-- eslint-disable -->
<template>
  <section class="message-comp">
    <div v-for="reply in replies" :key="reply._id" class="message-comp__item p-2 pb-0 mb-2 pointer animate__animated animate__fadeIn animate__slower"
         :class="{'receiver': reply.sent_by === 'Visitor'}"
         @click="$router.push({ name: 'reply-view', params: { id: reply._id } })">
      <p class="message-comp__item__message mb-0">{{reply.message}}</p>
      <p class="mb-0 pt-1 full-width d-flex justify-content-between">
        <small>{{reply.sender_name}}</small>
        <small>{{reply.created_at | formatDateTime}}</small>
      </p>
    </div>
    <p v-if="replies.length === 0" class="mb-0">No replies to show</p>
  </section>
</template>
<!-- eslint-enable -->

<script>
  export default {
    components: {},
    props: {
      replies: {
        required: true,
        type: Array,
      },
    },
    data() {
      return {
        test: '',
      };
    },
    mounted() {

    },
    methods: {

    },
  };
</script>
